/**
 * Sets a css4 variable for the view-height of the window.
 */
const setViewHeight = (): void => {
  document.documentElement.style.setProperty(
    '--view-height',
    `${window.innerHeight}px`
  );
};

/**
 * Sets a css4 variable for the view-width of the window.
 */
const setViewWidth = (): void => {
  document.documentElement.style.setProperty(
    '--view-width',
    `${document.body.clientWidth}px`
  );
};

/**
 * Handles setting a css4 variable to reflect the true height of the DOM,
 * This is intended to be used as a solution to the monbile view-height
 * issues usually faced with getting the height of the dom in reference
 * to the URL bar and action buttons.
 */
let timeout: NodeJS.Timeout;
export const setHeightVariable = (): void => {
  setViewHeight();
  setViewWidth();
  window.addEventListener('resize', () => {
    clearTimeout(timeout);
    // Set small delay to fix chrome rotation on IOS firing resize too early
    timeout = setTimeout(() => {
      setViewHeight();
      setViewWidth();
    }, 50);
  });
};
